import axios from '../../axios'

/*
 * 菜单管理模块
 */

 // 保存
export const save = (data) => {
    return axios({
        url: '/system/sysMenu/save',
        method: 'post',
        data
    })
}
 // 列表
export const list = (data) => {
    return axios({
        url: '/system/sysMenu/list',
        method: 'post',
        data
    })
}
 // 编辑
 export const edit = (data) => {
    return axios({
        url: '/system/sysMenu/edit',
        method: 'post',
        data
    })
}
 // 查看
 export const view = (data) => {
    return axios({
        url: '/system/sysMenu/view',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/system/sysMenu/delete',
        method: 'post',
        data
    })
}
// 左侧导航菜单树
export const findNavTree = (params) => {
  let param={
    method:'post',
    url: '/system/sysMenu/findNavTree',
    params
  }
  return axios(param);

    // return axios({
    //     url: '/system/sysMenu/findNavTree',
    //     method: 'post',
    //     params
    // })
}
//菜单图标
export const selectMenuIcons = (params) => {
  return axios({
    url: '/system/sysMenu/selectMenuIcons',
    method: 'post',
    params
  })
}
//查找children
export const findChildren = (data) => {
  return axios({
    url: '/system/sysMenu/findChildren',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/menu.js